import {
  CustomerContactInput,
  CustomerContactsContent,
  PaginatedCustomerContacts
} from 'types/CustomerContactsTypes';
import useHttp from '../helpers/HttpMethods';

const http = useHttp();

class ContactsService {
  /**
   * Busca os contatos paginados.
   * @param {number} filter - filtros em string.
   * @returns {Promise<PaginatedCustomerContacts>} - Contatos em formato paginado.
   */
  static async list(
    filter: string
  ): Promise<PaginatedCustomerContacts | Response> {
    return await http.get(`/contacts?${filter}`);
  }

  /**
   * Retorna um novo contato.
   * @param {CustomerContactInput} body - Modelo para criar um novo contato cliente.
   * @returns {Promise<Response | CustomerContactsContent>} - Modelo do objeto retornado na criação.
   */
  static async create(
    body: CustomerContactInput
  ): Promise<Response | CustomerContactsContent> {
    return await http.post(body, `/contacts`);
  }

  /**
   * Edita um contato.
   * @param {number} id - ID do contato a ser atualizada.
   * @param {CustomerContactInput} body - Modelo de contato para enviar os dados e atualizar.
   * @returns {Promise<Response | CustomerContactsContent>} - Retorno padrão de uma request ou
   * o contato atualizado.
   */
  static async edit(
    id: number,
    body: CustomerContactInput
  ): Promise<Response | CustomerContactsContent> {
    return await http.put(body, `/contacts/${id}`);
  }

  /**
   * Importa contatos apenas para pré-visualização.
   * @param {FormData} file - Arquivo para importar contatos.
   * @returns {Promise<Response>} - Retorno padrão de uma request.
   */
  static async importPreview(file: FormData): Promise<Response> {
    return await http.postFile(file, '/contacts/import/preview');
  }

  /**
   * Importa os contatos.
   * @param {FormData} file - Arquivo para importar contatos.
   * @returns {Promise<Response>} - Retorno padrão de uma request.
   */
  static async importProcess(file: FormData): Promise<Response> {
    return await http.postFile(file, '/contacts/import/process');
  }

  /**
   * Edita um contato.
   * @param {number} id - ID do contato a ser atualizada.
   * @returns {Promise<Response>} - Retorno padrão de uma request
   */
  static async resendInvite(id: number): Promise<Response> {
    return await http.post({}, `/contacts/${id}/resend-invite`);
  }
}

export default ContactsService;
